<template>
    <div :style="{ margin: '2rem' }">
      <DialogLoading
        :message="loadingMessage"
        :active="loading"
      />
      <ConfirmationModal
        :active="confirmModal"
        :handleConfirm="handleAcceptConfirmModal"
        :handleCancel="handleCancelConfirmModal"
        title="Cliente Atualizado"
        message="Você tem certeza que deseja marcar o cliente como atualizado?"
      />
      <v-card>
        <v-data-table
          :headers="headers"
          :items="clients"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          :disable-sort="true"
          :loading="loading"
          loading-text="Carregando... Por favor, aguarde"
          no-data-text="Nenhum cliente alterado"
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="title-bold">Clientes não atualizados no Sienge</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:[`item.field`]="{ item }">
            <div v-for="field in item.changes" :key="field.id">
                {{ field.name }}
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="openConfirmModal(item)"
                >
                  mdi-chevron-down-circle-outline
                </v-icon>
              </template>
              <span>Marcar como atualizado</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="handleViewClient(item)"
                >
                  mdi-eye-outline
                </v-icon>
              </template>
              <span>Ver cliente</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            Sem dados
          </template>
        </v-data-table>
        <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
      </v-card>
    </div>
  </template>

  <script>
  import DialogLoading from '@/components/loading/DialogLoading'
  import ConfirmationModal from '@/components/modals/ConfirmationModal'
  import message from '@/utils/message'
  import api from '@/services/api'

  export default {
    components: {
      DialogLoading,
      ConfirmationModal
    },

    data: () => ({
      itemToFinish: null,
      dialog: false,
      loading: true,
      loadingMessage: 'Carregando',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Nome', align: 'start', value: 'name' },
        { text: 'Campos', value: 'field' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      clients: [],
      editedIndex: -1,
      confirmModal: false
    }),

    created () {
      this.getClients()
    },

    methods: {
      async getClients () {
        try {
          this.loading = true
          const { data } = await api.get('/clients/changes')
          this.clients = data
        } catch (error) {
          message.error('Erro ao buscar clientes')
        } finally {
          this.loading = false
        }
      },

      async finished () {
        try {
          this.loading = true
          api.put(`/clients/${this.itemToFinish.id}/changes`)
          const index = this.clients.indexOf(this.itemToFinish)
          this.clients.splice(index, 1)
          message.success('Cliente Resolvido')
        } catch (error) {
          message.error('Erro na operação')
        } finally {
          this.loading = false
        }
      },

      handleCancelConfirmModal () {
        this.confirmModal = false
      },

      handleAcceptConfirmModal () {
        this.confirmModal = false
        this.finished()
      },

      openConfirmModal (item) {
        this.itemToFinish = item
        this.confirmModal = true
      },

      handleViewClient (item) {
        this.$router.push({ path: `/clientes/${item.id}/editar` })
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/clients/ClientChanges.vue